import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { DwButtonCommand, DwFormContextMode, DwButtonConfig, DwMessage, DwMessageSeverity, DwModalButtonStandardConfigs, DwModalConfig, DwModalHandler, DwModalResult, DwModalService, DwModalSize } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { PaymentChargeRequest } from '../../models/payment-charge-request.model';
import { CheckridePaymentRequest } from '../../models/checkride-payment-request.model';
import { PaymentModalOptions } from '../../models/payment-modal-options.model';
import { PaymentModalReturn } from '../../models/payment-modal-return.model';
import { PaymentRepositoryService } from '../../services/payment-repository.service';
import { CheckridePaymentResult } from '../../models/checkride-payment-result.model';
import { map, mergeMap } from 'rxjs/operators';
import { CheckRideRequestEntity, CheckRideRequestPaymentPartyAllItems, CheckRideRequestSubStatusAllItems } from '../../../../meta-data/app-meta-data.service';
import { CurrencyPipe } from '@angular/common';
import { PaymentDiscountResult } from '../../models/payment-discount-result.model';
import { CheckCalendarAvailabilityResultDTO } from '../../../examiner/models/check-calendar-availability-result.model';
import { CheckCalendarAvailabilityRequestDTO } from '../../../examiner/models/check-calendar-availability-request.model';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { PilexosUserTypeIds } from '../../../shared/models/pilexos-user-type.enum';

@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss'],
  providers: [CurrencyPipe]
})
export class PaymentModalComponent implements OnInit, DwModalHandler {
  chargeRequest: PaymentChargeRequest;

  modalConfig: DwModalConfig<PaymentModalOptions>;
  paymentModalOptions: PaymentModalOptions;
  closeModal: EventEmitter<DwModalResult<PaymentModalReturn>>;
  paymentComplete: boolean;

  processing: boolean = false;
  processingMessage: string;
  checkridePaymentResult: CheckridePaymentResult;

  additionalMessage: string;
  paymentDiscountResult: PaymentDiscountResult;

  constructor(private paymentRespotioryService: PaymentRepositoryService, private currencyPipe: CurrencyPipe, private examinerRepositoryService: ExaminerRepositoryService,
    private adminManagerService: AdminManagerService

  ) { }

  ngOnInit(): void {

    this.paymentModalOptions = this.modalConfig.data;
    this.chargeRequest = this.paymentModalOptions.chargeRequest || {} as any;

    // Ensure the card details are initialized
    this.chargeRequest.cardDetails = this.chargeRequest.cardDetails || {} as any;
   
    // Moved to the checkride Payment util for each user type (Applicant, Examiner, Flight School)
    // if (this.chargeRequest.cardOwnerPaymentPartyId != CheckRideRequestPaymentPartyAllItems.Applicant) {
    //   this.chargeRequest.markDefaultCard = true;
    //   this.chargeRequest.addCardToCustomer = true;
    // }

    if (this.paymentModalOptions.checkrideRequest.ExaminerBookingCost > 0) {
      const amount = this.currencyPipe.transform(this.paymentModalOptions.checkrideRequest.ExaminerBookingCost, 'USD', 'symbol', '1.2-2');

      this.additionalMessage = `This does not include the Examiner booking fee of ${amount} which is payable directly to the Examiner.`;
    }
    this.paymentModalOptions.showPaymentParty
  }



  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<PaymentModalReturn>> {
    const modalResult = new DwModalResult();

    modalResult.closeModal = true;
    modalResult.cancelled = false;
    modalResult.buttonCommand = buttonConfig.command;

    if (this.processing) {
      modalResult.cancelled = true;

      return of(modalResult);
    }

    switch (buttonConfig.command) {
      case DwButtonCommand.saveAndClose:

        if (!this.validateForm()) {
          modalResult.closeModal = false;

          return of(modalResult);
        }

        return this.processPayment();
      default:
        if (this.paymentComplete) {
          modalResult.data = {
            checkridePaymentResult: this.checkridePaymentResult
          };

          return of(modalResult)
        }

        // Otherwise we're cancelling
        modalResult.cancelled = true;

        return of(modalResult);
    }
  }

  processPayment(): Observable<DwModalResult<PaymentModalReturn>> {
    const checkridePaymentRequest: CheckridePaymentRequest = {
      checkRideRequestId: this.modalConfig.data.checkrideRequest.CheckRideRequestId,
      chargeRequest: this.chargeRequest,
    };

    this.processing = true;
    this.processingMessage = 'Validating Payment Information...';

    // Ensure that checkride is still available
    return this.checkCalendarAvailability()
      .pipe(mergeMap((isAvailable: boolean) => {
        const modalResult = new DwModalResult();

        if (!isAvailable) {
          modalResult.cancelled = true;
          this.processing = false;

          return of(modalResult);
        }
        return this.paymentRespotioryService.createCheckridePayment(checkridePaymentRequest)
          .pipe(map((checkridePaymentResult: CheckridePaymentResult) => {

            this.checkridePaymentResult = checkridePaymentResult;

             
            const modalResult = new DwModalResult();
            this.processing = false;

            if (!checkridePaymentResult.IsSuccess) {
              this.setMessage(checkridePaymentResult.ErrorMessage, DwMessageSeverity.error);

              modalResult.closeModal = false;

              return modalResult;
            }

            this.processingMessage = 'Updating Checkride...';

            modalResult.closeModal = false;

            this.paymentComplete = true;

            this.modalConfig.title = 'Checkride payment successful';
            this.modalConfig.buttons = [DwModalButtonStandardConfigs.instance.closeButton];

            return modalResult;
          }));
      }));

  }

  checkCalendarAvailability(): Observable<boolean> {
    const checkrideRequest: CheckRideRequestEntity = this.paymentModalOptions.checkrideRequest;
    const originalCheckrideRequest: CheckRideRequestEntity = this.paymentModalOptions.originalCheckrideRequest;
    ;
    if (!checkrideRequest) {
      return of(false);
    }

    if (originalCheckrideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.Draft &&
      originalCheckrideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.PendingPayment &&
      // originalCheckrideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.AcceptedPendingPayment &&
      originalCheckrideRequest?.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.Rejected
    ) { 
      // Always check on add
      if (this.modalConfig.data.formMode == DwFormContextMode.edit) {
        return of(true);
      }
    }

    if (this.modalConfig.data.formMode == DwFormContextMode.add) {

      var pilexosuser = this.adminManagerService.getPilexosUser();

      if (pilexosuser.UserTypeId == PilexosUserTypeIds.pilotExaminer) {
        console.debug('Skipping calendar availability check for Examiner booking');
        return of(true);
      }
    }

    const request: CheckCalendarAvailabilityRequestDTO = {
      CheckRideDateTime: checkrideRequest.ScheduledDateTime,
      DurationMinutes: checkrideRequest.ScheduledTimeMinutes,
      PilotExaminerId: checkrideRequest.ScheduledPilotExaminerId,
      CheckRideRequestId: checkrideRequest.CheckRideRequestId,
      FlightSchoolExaminerId: checkrideRequest.FlightSchoolExaminerId,
      CheckRideExaminerTypeId: checkrideRequest.CheckRideExaminerTypeId
    };

    return this.examinerRepositoryService.checkCalendarAvailability(request)
      .pipe(map((result: CheckCalendarAvailabilityResultDTO) => {
        if (result.Success && result.HasConflicts === false) {
          return true;
        }

        if (!result.Success) {
          this.setMessage(result.ErrorMessage, DwMessageSeverity.error);
        } else {
          this.setMessage('The selected checkride time is no longer available. Please select a different time.', DwMessageSeverity.error);
        }

        return false;
      }));
  }
  protected validateForm(): boolean {
    const errors: string[] = [];

    if (this.paymentDiscountResult?.FinalAmount > 0) {

      // Validate card details if not using a saved card
      if (!this.chargeRequest.cardDetails?.cardReferenceKey) {
        if (!this.chargeRequest.cardDetails?.cardholderName) {
          errors.push('Cardholder Name is required');
        }

        if (!this.chargeRequest.cardDetails?.cardNumber) {
          errors.push('Card number is required');
        }

        if (!this.chargeRequest.cardDetails?.expirationMonth) {
          errors.push('Expiration Month is required');
        }

        if (!this.chargeRequest.cardDetails?.expirationYear) {
          errors.push('Expiration Year is required');
        }

        if (!this.chargeRequest.cardDetails?.cVC) {
          errors.push('CVC is required');
        }

        if (!this.chargeRequest.cardDetails?.cardholderPostalCode) {
          errors.push('Postal Code is required');
        }
      }
    }

    if (errors.length > 0) {
      this.setMessage(errors.join(", "), DwMessageSeverity.error);

      return false;
    }

    this.message = null;

    return true;
  }

  message: DwMessage;

  private setMessage(messageBody: string, severity: DwMessageSeverity = DwMessageSeverity.info) {
    this.message = {
      messageBody: messageBody,
      severity: severity
    };
  }

}
